import React from 'react';
import { Tabs, TabContent, TabHeader } from '../Tabs';
import cx from 'clsx';
import styles from './GameDetails.module.scss';
import { CallbackMode } from '../../logic/main/types';
import GameInfoContent, { GameInfoContentMessages } from './GameInfoContent';
import GameRulesContent from './GameRulesContent';
import { GameTileProps, GameClickProps } from '../modular-grid/types';
import GameDetailsTop, { GameDetailsTopMessages } from './GameDetailsTop';
import { mapUrl } from '../../logic/main/utils';
import { DeviceContext } from '../DeviceProvider/DeviceProvider';

interface GameDetailsMessages {
  gameInfo: string;
  gameRules: string;
  playButton: string;
  gameDetailsTop: GameDetailsTopMessages;
  gameInfoContent: GameInfoContentMessages;
}
interface GameDetailsPropTypes {
  game: GameTileProps;
  callbackMode: CallbackMode;
  onGameButtonClick: ({
    game,
    gamePosition,
    sectionTitle,
  }: {
    game: GameClickProps;
    gamePosition: number;
    sectionTitle: string;
  }) => void;
  staticTexts: GameDetailsMessages;
}

const GameDetails: React.FC<GameDetailsPropTypes> = ({
  game,
  onGameButtonClick,
  callbackMode,
  staticTexts,
}) => {
  const { deviceType, deviceOs } = React.useContext(DeviceContext);
  if (!game) return null;

  const GameDetailsCmp = (
    <div>
      <GameDetailsTop
        game={game}
        callbackMode={callbackMode}
        onGameButtonClick={onGameButtonClick}
        staticTexts={staticTexts.gameDetailsTop}
      />
      <div className={styles.gameDetailsMain}>
        <Tabs
          initialValue="description"
          tabsTop={
            <>
              <TabHeader name="description">{staticTexts.gameInfo}</TabHeader>
              {game.rules && (
                <TabHeader name="rules">{staticTexts.gameRules}</TabHeader>
              )}
            </>
          }
          tabsContent={
            <>
              <div className={styles.tabContentWrapper}>
                <TabContent name="description">
                  <GameInfoContent
                    game={game}
                    staticTexts={staticTexts.gameInfoContent}
                  />
                </TabContent>
              </div>
              <div className={styles.tabContentWrapper}>
                <TabContent name="rules">
                  <GameRulesContent game={game} />
                </TabContent>
              </div>
            </>
          }
        />
      </div>
      <div className={styles.gameDetailsFooter}>
        <a
          className={cx(styles.link, styles.detailsLink)}
          target="_blank"
          rel={`noopener noreferrer ${game.notIndexed ? 'nofollow' : ''}`}
          href={mapUrl(game.launchUrl, deviceType, deviceOs)}
          onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
            if (callbackMode === 'event') e.preventDefault();
            onGameButtonClick &&
              onGameButtonClick({
                game,
                gamePosition: 1,
                sectionTitle: 'Game Details',
              });
          }}
        >
          {staticTexts.playButton}
        </a>
      </div>
    </div>
  );

  return GameDetailsCmp;
};

export default GameDetails;
